import { useState } from "react";
import { useNavigate } from "react-router";
import {
  Box,
  Paper,
  Stack,
  Button,
  Typography,
  TextField,
} from "@mui/material";
import { translate } from "../../utils/localisation";

export function PetProfileSearch() {
  const navigate = useNavigate();
  const [id, setId] = useState("");

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!id.trim()) return;
    navigate(`/pet-profile-edit/${id.trim()}`);
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 720,
        mx: "auto",
        px: { xs: 1.5, sm: 2 },
        py: { xs: 1, sm: 2 },
      }}
    >
      <Typography
        sx={{
          typography: { xs: "h6", sm: "h5", md: "h4" },
          fontWeight: 700,
          mb: 0.5,
        }}
      >
        {translate("pet-medical-records-screen.title-text")}
      </Typography>
      <Typography
        sx={{
          color: "text.secondary",
          mb: 2,
          typography: { xs: "body2", sm: "body1" },
        }}
      >
        {translate("pet-medical-records-screen.subtitle-text")}
      </Typography>

      <Paper
        elevation={0}
        sx={{
          p: { xs: 1.5, sm: 2 },
          borderRadius: 3,
          border: theme => `1px solid ${theme.palette.divider}`,
          backgroundImage: "none",
        }}
      >
        <form onSubmit={onSubmit}>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1}
            alignItems={{ xs: "stretch", sm: "center" }}
          >
            <TextField
              size="small"
              type="text"
              value={id}
              onChange={e => setId(e.target.value)}
              placeholder={translate(
                "pet-medical-records-screen.subtitle-text"
              )}
              fullWidth
              InputProps={{ sx: { height: 40 } }}
            />
            <Button
              variant="contained"
              type="submit"
              disabled={!id.trim()}
              sx={{
                minWidth: { sm: 120 },
                height: 40,
                fontWeight: 700,
                bgcolor: "#210C03",
                "&:hover": { bgcolor: "#3a1a0b" },
              }}
            >
              {translate("go_uppercase")}
            </Button>
          </Stack>
        </form>
      </Paper>
    </Box>
  );
}
